module.exports = __webpack_public_path__ + "static/media/burgers.40c2a6fb.jpeg";